"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
exports.default = (0, material_1.styled)(material_1.Box)(function () { return ({
    display: 'flex',
    justifyContent: 'space-around',
}); });
